import { __assign, __read, __rest } from "tslib";
import React, { useState, useEffect, useRef } from 'react';
import { Tooltip } from '@hose/eui';
import './index.module.less';
export default function TooltipEllipsis(props) {
    var childrenRef = useRef(null);
    var children = props.children, title = props.title, width = props.width, other = __rest(props, ["children", "title", "width"]);
    var _a = __read(useState(false), 2), showTooltip = _a[0], setShowTooltip = _a[1];
    useEffect(function () {
        validShowTooltip();
    }, [title, width]);
    var validShowTooltip = function () {
        if (!childrenRef) {
            return;
        }
        var _a = childrenRef, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
        setShowTooltip(scrollWidth > clientWidth);
    };
    var refChildren = function (ref) {
        childrenRef = ref;
    };
    var renderChildren = function () {
        return (React.cloneElement(React.createElement("span", { className: "ellipsis-children" }, children), {
            ref: refChildren
        }));
    };
    if (showTooltip) {
        return (React.createElement(Tooltip, __assign({ title: title, trigger: "hover", placement: "top" }, other), renderChildren()));
    }
    return renderChildren();
}
